import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DetailTasksetComponent } from './detail-taskset.component';
import { AngularFrameworkModule } from 'sp-office365-framework';
import { TranslateModule } from '@ngx-translate/core';
import { FormioModule } from '@formio/angular';
import { TableTaskModule } from '../../task/table-task/table-task.module';
import { TableTasktemplateModule } from '../../tasktemplate/table-tasktemplate/table-tasktemplate.module';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatTabsModule } from '@angular/material/tabs';
import { MatToolbarModule } from '@angular/material/toolbar';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { MatIconModule } from '@angular/material/icon';

@NgModule({
    declarations: [DetailTasksetComponent],
    imports: [
        CommonModule,
        AngularFrameworkModule,
        TranslateModule,
        MatTabsModule,
        MatSnackBarModule,
        MatToolbarModule,
        MatIconModule,
        TableTaskModule,
        FormioModule,
        FormioModule,
        TableTasktemplateModule,
        DragDropModule,
    ],
    exports: [DetailTasksetComponent],
})
export class DetailTasksetModule {}
